import type { ReactElement } from 'react';
import { shoppingPdfUrl } from '../../api/shopping.js';

export interface PdfButtonProps {
  listId: number | null;
}

export function PdfButton({ listId }: PdfButtonProps): ReactElement {
  if (listId === null) {
    return (
      <button
        type="button"
        disabled
        className="flex min-h-[40px] items-center rounded-md border px-3 text-sm"
        style={{
          borderColor: 'var(--border)',
          color: 'var(--text-muted)',
          background: 'transparent',
          opacity: 0.6,
        }}
        data-testid="shopping-pdf"
      >
        📄 PDF
      </button>
    );
  }
  return (
    <a
      href={shoppingPdfUrl(listId)}
      className="flex min-h-[40px] items-center rounded-md border px-3 text-sm"
      style={{
        borderColor: 'var(--accent)',
        color: 'var(--accent)',
        background: 'transparent',
        textDecoration: 'none',
      }}
      data-testid="shopping-pdf"
    >
      📄 PDF
    </a>
  );
}
